import {
  TIMESTAMP_MODE,
  type TimestampMode,
} from "@/types/tables/ConversationsTable"

/**
 * Normalize legacy saved view config values from camelCase to snake_case.
 * Views may have been saved with camelCase prior to Apr 2026,
 * so we accept both forms and normalize to the current convention.
 */

const LEGACY_TIMESTAMP_MAP: Record<string, TimestampMode> = {
  createdAt: TIMESTAMP_MODE.CREATED_AT,
  occurredAt: TIMESTAMP_MODE.OCCURRED_AT,
}

const LEGACY_COLUMN_MAP: Record<string, string> = {
  createdAt: TIMESTAMP_MODE.CREATED_AT,
  occurredAt: TIMESTAMP_MODE.OCCURRED_AT,
  simulationOutputId: "simulation_output_id",
}

export function normalizeTimestampMode(raw: string): TimestampMode {
  return LEGACY_TIMESTAMP_MAP[raw] ?? (raw as TimestampMode)
}

export function normalizeSortColumn(raw: string): string {
  return LEGACY_COLUMN_MAP[raw] ?? raw
}

export function normalizeVisibleColumns(columns: string[]): string[] {
  return columns.map((col) => LEGACY_COLUMN_MAP[col] ?? col)
}
